var _rect, _rect2, _path, _g, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 396,
    viewBox: "0 0 311 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2954_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 311,
    height: 396
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 396,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2954_186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2954_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 214,
    width: 157,
    height: 209
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 214,
    width: 157,
    height: 209,
    fill: "url(#paint0_linear_2954_186)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2954_186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2954_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 214,
    width: 157,
    height: 210
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.149 423.167C230.968 423.167 234.875 419.26 234.875 414.44V222.726C234.875 217.907 230.968 214 226.149 214H86.7153C81.902 214 78 217.902 78 222.716V309.868C78 314.681 81.902 318.583 86.7153 318.583H120.487V362.16C120.487 366.973 124.389 370.875 129.202 370.875H162.974V414.44C162.974 419.26 166.881 423.167 171.7 423.167H226.149Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2954_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.875 414.44V222.726C234.875 217.907 230.967 214 226.149 214H171.7C166.881 214 162.974 217.907 162.974 222.726V414.44C162.974 419.26 166.881 423.167 171.7 423.167H226.149C230.969 423.167 234.875 419.26 234.875 414.44Z",
    fill: "url(#paint1_linear_2954_186)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2954_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.388 362.16V214H120.487V362.16C120.487 366.973 124.389 370.875 129.202 370.875H183.672C188.486 370.875 192.388 366.973 192.388 362.16Z",
    fill: "url(#paint2_linear_2954_186)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78 309.868V222.715C78 217.902 81.902 214 86.7153 214H149.901V309.868C149.901 314.681 145.999 318.583 141.186 318.583H86.7153C81.902 318.583 78 314.681 78 309.868Z",
    fill: "url(#paint3_linear_2954_186)",
    fillOpacity: 0.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2954_186)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 156,
    cy: 220,
    rx: 91,
    ry: 5,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2954_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 6,
    width: 157,
    height: 210
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.149 6C230.968 6 234.875 9.90683 234.875 14.7262V206.44C234.875 211.259 230.968 215.167 226.149 215.167H86.7153C81.902 215.167 78 211.264 78 206.451V119.299C78 114.485 81.902 110.583 86.7153 110.583H120.487V67.007C120.487 62.1937 124.389 58.2917 129.202 58.2917H162.974V14.7262C162.974 9.90684 166.881 6 171.7 6H226.149Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2954_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.875 14.7262V206.44C234.875 211.259 230.967 215.167 226.149 215.167H171.7C166.881 215.167 162.974 211.259 162.974 206.44V14.7262C162.974 9.90684 166.881 6 171.7 6H226.149C230.969 6 234.875 9.90683 234.875 14.7262Z",
    fill: "url(#paint4_linear_2954_186)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2954_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.388 67.0068V215.167H120.487V67.0068C120.487 62.1935 124.389 58.2915 129.202 58.2915H183.672C188.486 58.2915 192.388 62.1935 192.388 67.0068Z",
    fill: "url(#paint5_linear_2954_186)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78 119.299V206.451C78 211.265 81.902 215.167 86.7153 215.167H149.901V119.299C149.901 114.485 145.999 110.583 141.186 110.583H86.7153C81.902 110.583 78 114.485 78 119.299Z",
    fill: "url(#paint6_linear_2954_186)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2954_186",
    x: -12.8463,
    y: 114,
    width: 338.568,
    height: 423.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2954_186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 33.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2954_186",
    result: "effect2_dropShadow_2954_186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2954_186",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2954_186",
    x: 52,
    y: 202,
    width: 208,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_2954_186"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2954_186",
    x: -12.8463,
    y: -41.7086,
    width: 338.568,
    height: 423.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2954_186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 33.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 66.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2954_186",
    result: "effect2_dropShadow_2954_186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2954_186",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2954_186",
    x1: 156.5,
    y1: 214,
    x2: 156.5,
    y2: 423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2954_186",
    x1: 150.99,
    y1: 423.167,
    x2: 241.126,
    y2: 226.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2954_186",
    x1: 120.481,
    y1: 370.875,
    x2: 196.413,
    y2: 219.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2954_186",
    x1: 77.9941,
    y1: 318.583,
    x2: 119.805,
    y2: 216.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2954_186",
    x1: 150.99,
    y1: 6,
    x2: 241.126,
    y2: 203.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2954_186",
    x1: 120.481,
    y1: 58.2915,
    x2: 196.413,
    y2: 210.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2954_186",
    x1: 77.9941,
    y1: 110.583,
    x2: 119.805,
    y2: 212.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerImg);
export default __webpack_public_path__ + "static/media/power-img.a9b6cbdf9729ac7891f734a1cb3d3ee2.svg";
export { ForwardRef as ReactComponent };